/**
 * Common button component
 *
 * Properties:
 *
 *      placeholder:        string, placeholder for selectbox
 *      zIndex:             number, optional z-index to control UI overlapping
 *      selectHandle:       function, callback to trigger actions after selecting an item
 *      queryHandle:        function, callback to trigger search query
 *      data:               array of objects with at least attributes:
 *                              name:   string, default displayed value in list (can be replaced by 'nameAttribute')
 *                              id:     id of item to re-identify it in list
 *      nameAttribute:      string, attribute to display in result list (optional)
 */

import React, { useState, useEffect } from "react";
import ComboSelectItem from "./comboselectitem";
// @ts-ignore
import {in_array} from "../../utils/Helper";

type Props = {
    selectedItems: (any)[],
    setSelectedItems: (items: any) => void|null,
    placeholder?: string,
    data: any,
    valkey: string,
    valprop: string,
    triggerOnChange: () => void
};
const Multiselect = ({selectedItems,setSelectedItems, data,valkey,valprop, triggerOnChange}: Props) => {
    const [itemResultsHidden,setItemResultsHidden] = useState(true);
    const [settedIds, setSettedIds] = useState([]);
    useEffect(() => {
        if(selectedItems.length > 0 && settedIds.length === 0){
            // @ts-ignore
            let clone = [];
            selectedItems.map(sel => {
                clone.push(sel[valkey]);
            });
            // @ts-ignore
            setSettedIds(clone);
        }
    },[]);
    useEffect(() => {
        if(typeof triggerOnChange === 'function'){
            triggerOnChange();
        }
    },[selectedItems]);
    const onClicked = () => {
        setItemResultsHidden(false);
    };
    const onClickedA = (e: React.MouseEvent<HTMLSpanElement>) => {
        setItemResultsHidden(!itemResultsHidden);
    };
    const onItemsSelectHandle = (e: any,item:any) => {
        if (!e.target.parentNode.classList.contains("selected")) {
            let clone = [];
            clone = [...selectedItems];
            let newObj: any = {};
            newObj[valkey] = item[valkey];
            newObj[valprop] = item[valprop];
            clone.push(newObj);
            setSelectedItems(clone);
        };
        setItemResultsHidden(true);
        let clone2 = [...settedIds];
        // @ts-ignore
        clone2.push(item[valkey]);
        setSettedIds(clone2);
    }
    const onRemoveHandler = (e:  React.MouseEvent<HTMLSpanElement>,item: any,index: number) => {
        let clone = [...selectedItems];
        clone.splice(index,1);
        setSelectedItems(clone);
        if(in_array(item[valkey],settedIds)){
            let clone2 = [...settedIds];
            let ind = null;
            clone2.map((val,i) => {
                if(val === item[valkey]){
                    ind = i;
                }
            });
            if(ind !== null){
                clone2.splice(ind,1);
                setSettedIds(clone2);
            }
        }
    }
    // @ts-ignore
    return (
        <div className="inb-form__controllClass">
                            <span
                                className="select2 select2-container select2-container--default select2-container--focus"
                                dir="ltr" data-select2-id="2" style={{width: 'auto'}}  onClick={(e: React.MouseEvent<HTMLSpanElement>)=>onClickedA(e)}>
                                    <span className="selection">
                                        <span className="select2-selection select2-selection--multiple" role="combobox"
                                              aria-haspopup="true" aria-expanded="false" tabIndex={-1}>
                                            <ul className="select2-selection__rendered"
                                                onClick={()=>onClicked()}>
                                                {selectedItems.length > 0 && selectedItems.map((item,index) => {
                                                    if(typeof item[valkey] !== 'undefined') {
                                                        return ( <ComboSelectItem
                                                                item={item}
                                                                value={item[valprop]}
                                                                index={index}
                                                                onRemoveHandler={onRemoveHandler}
                                                            />
                                                        );
                                                    }
                                                })}

                                            </ul>
                                        </span>
                                    </span>
                                    <ul className={'inbooma-select-box-results' + (itemResultsHidden === true ? ' hide' : '')}
                                        style={{width: '100%'}}>
                                        {// @ts-ignore
                                            data.map(item => {
                                            return (
                                                <>{!in_array(item[valkey],settedIds) && <li className={"inbooma-select-box-results__field"}
                                                    key={item[valkey]} value={item[valkey]}
                                                    onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                                                        onItemsSelectHandle(e, item)
                                                    }}>
                                                    <span style={{width: '100%'}}>{item[valprop]}</span>
                                                </li>}</>
                                            );
                                        })}
                                    </ul>
                                </span>
        </div>
    );
};
export default Multiselect;